export const loginRouteName = "Login";
export const notFoundRouteName = "NotFound";

export default [
  {
    name: loginRouteName,
    path: "/login",
    component: () => import("@/pages/Login.vue"),
    meta: {
      top: true,
      grant: "anonymous",
    },
  },

  {
    path: "/select-site",
    name: "SelectSite",
    component: () =>
      import("@/pages/SelectSite.vue").catch(() => {
        console.warn("SelectSite.vue 로드 실패, 대체 컴포넌트 사용");
        return import("@/pages/DashboardInnerTab.vue");
      }),
    meta: {
      top: true, // 전체 페이지로 표시
      grant: "anonymous", // 익명 접근 허용
    },
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/pages/Home.vue"),
    meta: {
      currentMenu: "HOME",
      title: "전체현황",
      permission: "USER,MANAGER,ADMIN",
      grant: "anonymous", // 인증된 사용자 접근 허용
    },
  },
  {
    path: "/",
    name: "Dashboard Inner Tab",
    component: () => import("@/pages/DashboardInnerTab.vue"),
    meta: {
      currentMenu: "COM",
    },
  },

  // 사용자 관리 페이지 라우트 추가
  {
    path: "/user-management",
    name: "UserManagement",
    component: () => import("@/pages/user/UserManagementPage.vue"),
    meta: {
      title: "계정 관리",
      menu: "COM", // 공통관리 메뉴에 속함
      permission: "MANAGER,ADMIN",
      icon: "user",
    },
  },

  // 모니터링 관련 라우트
  {
    path: "/monitoring",
    name: "Monitoring",
    component: () => import("@/pages/Monitoring.vue"),
    meta: {
      title: "통합 모니터링",
      menu: "MONITORING",
      permission: "USER,MANAGER,ADMIN",
    },
  },

  // 로봇 제어 관련 라우트
  {
    path: "/robot-control",
    name: "RobotControl",
    component: () => import("@/pages/robot/RobotControl.vue"),
    meta: {
      title: "로봇 상세 제어",
      menu: "ROBOT_CONTROL",
      permission: "USER,MANAGER,ADMIN",
    },
  },
  {
    path: "/patrol-robot",
    name: "PatrolRobot",
    component: () => import("@/pages/robot/RobotControl.vue"),
    meta: {
      title: "순찰로봇",
      menu: "ROBOT_CONTROL",
      permission: "USER,MANAGER,ADMIN",
    },
  },
  {
    path: "/cleanning-robot",
    name: "CleanningRobot",
    component: () => import("@/pages/robot/RobotControl.vue"),
    meta: {
      title: "청소로봇",
      menu: "ROBOT_CONTROL",
      permission: "MANAGER,ADMIN",
    },
  },
  {
    path: "/barista-robot",
    name: "BaristaRobot",
    component: () => import("@/pages/robot/RobotControl.vue"),
    meta: {
      title: "바리스타로봇",
      menu: "ROBOT_CONTROL",
      permission: "USER,MANAGER,ADMIN",
    },
  },
  {
    path: "/carry-robot",
    name: "CarryRobot",
    component: () => import("@/pages/robot/RobotControl.vue"),
    meta: {
      title: "캐리 로봇",
      menu: "ROBOT_CONTROL",
      permission: "USER,MANAGER,ADMIN",
    },
  },
  // 리포트 관련 라우트
  {
    path: "/report",
    name: "Report",
    component: () => import("@/pages/report/ServiceDashboard.vue"),
    meta: {
      title: "서비스별 진행현황",
      menu: "REPORT",
      permission: "USER,MANAGER,ADMIN",
    },
  },
  {
    path: "/service-order",
    name: "ServiceOrderReport",
    component: () => import("@/pages/report/ServiceOrderPage.vue"),
    meta: {
      title: "서비스 오더 로그",
      menu: "REPORT",
      permission: "USER,MANAGER,ADMIN",
    },
  },
  {
    path: "/robot-alarm",
    name: "RobotAlarmLog",
    component: () => import("@/pages/report/AlarmLogPage.vue"),
    meta: {
      title: "로봇 알람 로그",
      menu: "REPORT",
      permission: "USER,MANAGER,ADMIN",
    },
  },
  {
    path: "/monthly-report",
    name: "MonthlyRobotReport",
    component: () => import("@/pages/report/MonthlyReportPage.vue"),
    meta: {
      title: "Monthly Report",
      menu: "REPORT",
      permission: "USER,MANAGER,ADMIN",
    },
  },

  // 공통관리 관련 라우트

  {
    path: "/site-management",
    name: "SiteManagement",
    component: () => import("@/pages/site/SiteManagementPage.vue"),
    meta: {
      title: "사이트 관리",
      menu: "COM",
      permission: "MANAGER,ADMIN",
    },
  },
  {
    path: "/common-code-management",
    name: "CodeManagement",
    component: () => import("@/pages/code/CommonCodeManagementPage.vue"),
    meta: {
      title: "공통코드 관리",
      menu: "COM",
      permission: "MANAGER,ADMIN",
    },
  },
  {
    path: "/station-management",
    name: "StationManagement",
    component: () => import("@/pages/common/StationManagement.vue"),
    meta: {
      title: "스테이션 관리",
      menu: "COM",
      permission: "MANAGER,ADMIN",
    },
  },
  {
    path: "/robot-group-management",
    name: "RobotGroupManagement",
    component: () => import("@/pages/robotGroup/RobotGroupManagementPage.vue"),
    meta: {
      title: "로봇 그룹 관리",
      menu: "COM",
      permission: "MANAGER,ADMIN",
    },
  },
  {
    path: "/robot-management",
    name: "RobotManagement",
    component: () => import("@/features/robot/RobotManagement.vue"),
    meta: {
      title: "로봇 관리",
      menu: "COM",
      permission: "MANAGER,ADMIN",
    },
  },
  {
    path: "/map-management",
    name: "MapManagement",
    component: () => import("@/pages/map/MapManagementPage.vue"),
    meta: {
      title: "맵 관리",
      menu: "COM",
      permission: "MANAGER,ADMIN",
    },
  },
  {
    path: "/zone-management",
    name: "ZoneManagement",
    component: () => import("@/pages/zone/ZoneManagementPage.vue"),
    meta: {
      title: "Zone 관리",
      menu: "COM",
      permission: "MANAGER,ADMIN",
    },
  },
  // 서비스 관리 관련 라우트
  {
    path: "/service-management",
    name: "ServiceManagement",
    component: () => import("@/pages/service/ServiceManagement.vue"),
    meta: {
      title: "서비스 등록",
      menu: "SERVICE",
      permission: "MANAGER,ADMIN",
    },
  },
  {
    path: "/service-execution",
    name: "ServiceExecution",
    component: () => import("@/pages/service/ServiceExecutionPage.vue"),
    meta: {
      title: "서비스 실행",
      menu: "SERVICE",
      permission: "MANAGER,ADMIN",
    },
  },
  {
    path: "/household",
    name: "HouseholdManagement",
    component: () => import("@/pages/cafe/HouseholdManagementPage.vue"), // 임시로 userManagement 연결
    meta: {
      title: "가정 관리",
      menu: "CAFE",
      permission: "MANAGER,ADMIN",
    },
  },
  {
    path: "/phone-number-mapping",
    name: "TelephoneManagement",
    component: () => import("@/pages/common/TelephoneNumberManagementPage.vue"),
    meta: {
      title: "전화번호 관리",
      menu: "COM",
      permission: "MANAGER,ADMIN",
    },
  },
  {
    path: "/cafe-order-info",
    name: "CafeOrderManagement",
    component: () => import("@/pages/cafe/CafeOrderManagementPage.vue"),
    meta: {
      title: "카페 오더 관리",
      menu: "CAFE",
      permission: "MANAGER,ADMIN",
    },
  },
  {
    path: "/cafe-order-stats",
    name: "CafeOrderStats",
    component: () => import("@/pages/cafe/CafeOrderStatsPage.vue"),
    meta: {
      title: "카페 오더 통계",
      menu: "CAFE",
      permission: "MANAGER,ADMIN",
    },
  },
  {
    path: "/alarm-role-mapping",
    name: "AlarmRoleMapping",
    component: () => import("@/pages/alarm/AlarmRoleMappingPage.vue"),
    meta: {
      title: "Alarm Role Mapping",
      menu: "COM",
      permission: "MANAGER,ADMIN",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
  {
    name: notFoundRouteName,
    path: "/404",
    component: () => import("@/pages/404/PageNotFound.vue"),
    meta: {
      top: true,
      grant: "anonymous",
    },
  },
];
